import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Icon } from "semantic-ui-react";
import Files from "react-files";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { newWiki } from "../../store/actions/wikiActions";
import { allowed } from "../../utils/utils";

const EditWiki = (props) => {
  const [error, setError] = useState(false);
  const [title, setTitle] = useState(null);
  const [file, setFile] = useState(null);
  const [name, setName] = useState(null);

  const dispatch = useDispatch();
  const close = () => {
    setFile(null);
    setTitle(null);
    setName(null);
    setError(null);
    props.close();
  };

  useEffect(() => {
    if (props.wikiAdded) {
      close();
    }
  }, [props.wikiAdded]);

  const handleSubmit = () => {
    const data = {
      id: props.open?.id,
      forAdvocate: props.open?.forAdvocate,
      fileName: title ? title : props.open?.fileName,
    };
    if (file) {
      data.file = file;
    } else data.file = null;
    dispatch(newWiki(data));
  };

  return (
    <Modal
      size="tiny"
      className="cu-event-modal"
      onClose={() => close()}
      open={props.open}
    >
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={() => close()}
            />
            <Button
              disabled={error || props.wikiError ? true : false}
              loading={props.wikiAdding}
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          </div>
          {(error || props.wikiError) && (
            <>
              error &&<p style={{ color: "#800000" }}>{error}</p>
              props.wikiError &&
              <p style={{ color: "#800000" }}>{props.wikiError}</p>
            </>
          )}
        </div>
        <Form>
          <div className="AdminFormEventContainer">
            <h3>Edit Wiki</h3>
            <Form.Field required>
              <label>Document Name</label>
              <input
                placeholder="Enter document name"
                id="dname"
                defaultValue={props.open?.fileName}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Field>

            <div className="form-group cu-center">
              <Files
                className="files-dropzone"
                accepts={allowed}
                clickable
                multiple={false}
                onChange={(file) => {
                  setFile(file[0]);
                  setName(file[0].name);
                }}
              >
                <label className="btn-cu ui green button btn-cu">
                  <Icon name="upload" />
                  Upload Document
                </label>
              </Files>
              {name && <p className="note">{name}</p>}
            </div>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    superAdmin: state.auth.superAdmin,

    wikiError: state.wiki.newDocumentAddError,
    wikiAdded: state.wiki.newDocumentAdd,
    wikiAdding: state.wiki.newDocumentAdding,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "wiki",
    },
  ])
)(EditWiki);
